/* global mixpanel */

/**
 */
export function ftueCompleted () {
  mixpanel.track('FTUE Employee')
}



// WEBPACK FOOTER //
// ./app/mixpanel/employees/ftue.js